import { FC } from 'react';
import { Box, Typography, Avatar, IconButton, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';

import styles from './TravelBuddiesSection.module.scss';
import { TravelBuddy } from '../../../../../types/trip.types';
import { DeleteIcon, InviteUserIcon } from '../../../../../components/Icons';
import { buildAvatarUrl, generateInitials } from '../../../../../utils/avatarUtils';

type TravelBuddiesSectionProps = {
  selectedBuddies: TravelBuddy[];
  onAddBuddies: () => void;
  onRemoveBuddy: (buddyId: number) => void;
};

const TravelBuddiesSection: FC<TravelBuddiesSectionProps> = ({ selectedBuddies, onAddBuddies, onRemoveBuddy }) => {
  const getBuddyDisplayName = (buddy: TravelBuddy) => {
    if (buddy.first_name || buddy.last_name) {
      return `${buddy.first_name} ${buddy.last_name}`.trim();
    }
    return buddy.username;
  };

  return (
    <Box className={styles.travelBuddiesSection}>
      <Box
        className={styles.addBuddiesButton}
        onClick={onAddBuddies}
      >
        <InviteUserIcon />
        <Typography
          variant="h10Semibold"
          sx={{ color: '#5E6A81' }}
        >
          Add Travel Buddies
        </Typography>
      </Box>

      {selectedBuddies.length > 0 && (
        <Box className={styles.buddiesList}>
          <List>
            {selectedBuddies.map(buddy => {
              const avatarUrl = buildAvatarUrl(buddy.profile_picture);
              const initials = generateInitials(buddy.first_name, buddy.last_name, buddy.email, buddy.username);

              return (
                <ListItem
                  key={buddy.id}
                  className={styles.buddyItem}
                >
                  <ListItemIcon>
                    <Avatar
                      className={styles.buddyAvatar}
                      src={avatarUrl || undefined}
                      sx={{
                        width: 50,
                        height: 50,
                        backgroundColor: avatarUrl ? 'transparent' : '#e3f2fd',
                        color: '#0098f0',
                        fontWeight: 600,
                        fontSize: 14,
                      }}
                      slotProps={{
                        img: {
                          style: {
                            objectFit: 'cover',
                            objectPosition: 'center',
                          },
                        },
                      }}
                    >
                      {!avatarUrl && initials}
                    </Avatar>
                  </ListItemIcon>

                  <ListItemText>
                    <Typography
                      variant="h9Semibold"
                      sx={{ color: '#222B3A' }}
                    >
                      {getBuddyDisplayName(buddy)}
                    </Typography>
                  </ListItemText>

                  <IconButton
                    size="small"
                    onClick={() => onRemoveBuddy(buddy.id)}
                    className={styles.deleteButton}
                  >
                    <DeleteIcon />
                  </IconButton>
                </ListItem>
              );
            })}
          </List>
        </Box>
      )}
    </Box>
  );
};

export default TravelBuddiesSection;
